import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
        // submenu: [
        //     {
        //         id: 11,
        //         title: 'Home 1',
        //         link: '/home'
        //     },
        //     {
        //         id: 12,
        //         title: 'Home 2',
        //         link: '/home-2'
        //     },
        //     {
        //         id: 13,
        //         title: 'Home 3',
        //         link: '/home-3'
        //     },
        //     {
        //         id: 14,
        //         title: 'Home 4',
        //         link: '/home-4'
        //     }
        // ]
    },
    {
        id: 2,
        title: 'About Us',
        link: '#',
        submenu: [
            {
                id: 11,
                title: 'Who We Are?',
                link: '/about-us/who-we-are'
            },
            {
                id: 12,
                title: 'Our Journey',
                link: '/about-us/our-journey'
            },
            {
                id: 13,
                title: 'Leadership Team',
                link: '/about-us/leadership-team'
            },
        ]
    },
    {
        id: 3,
        title: 'Our Initiative',
        link: '#',
        submenu: [
            {
                id: 31,
                title: 'SevakArmy',
                link: '/initiatives/sevak-army'
            },
            {
                id: 32,
                title: 'LifeSaverArmy',
                link: '/initiatives/life-saver-army'
            },
            {
                id: 33,
                title: 'MyFoodChecker',
                link: '/initiatives/my-food-checker'
            },
            {
                id: 34,
                title: 'MindUnload',
                link: '/initiatives/mind-unload'
            },
            {
                id: 35,
                title: 'AkshayNetra',
                link: '/initiatives/akshay-netra'
            },
            {
                id: 36,
                title: 'YoungJains',
                link: '/initiatives/young-jains'
            },
            {
                id: 37,
                title: 'ReformArmy',
                link: '/initiatives/reform-army'
            },
            {
                id: 37,
                title: 'PledgeMyOrgans',
                link: '/initiatives/pledge-my-organs'
            },
        ]
    },

    {
        id: 4,
        title: 'Impact & Stories',
        link: '#',
        submenu: [
            {
                id: 41,
                title: 'Success Stories',
                link: '/impact/success-stories'
            },
            {
                id: 42,
                title: 'Testimonials',
                link: '/impact/testimonials'
            },
            {
                id: 43,
                title: 'Achievements',
                link: '/impact/achievements'
            },
        ]
    },

    {
        id: 5,
        title: 'Gallery',
        link: '#',
        submenu: [
            {
                id: 51,
                title: 'Tree Plantation',
                link: '/gallery/tree-plantation'
            },
            {
                id: 52,
                title: 'Blood Donation',
                link: '/gallery/blood-donation'
            },
            {
                id: 51,
                title: 'Orphanage Visit',
                link: '/gallery/orphanage-visit'
            },
            {
                id: 52,
                title: 'Handicap Center Visit',
                link: '/gallery/handicap-center-visit'
            },
            {
                id: 53,
                title: 'Food Donation Drive',
                link: '/gallery/food-donation-drive'
            },
            {
                id: 54,
                title: 'School & College Outreach',
                link: '/gallery/school-activity'
            },
            {
                id: 55,
                title: 'Sticker Campaign',
                link: '/gallery/sticker-campaign'
            },
             {
                id: 56,
                title: 'Public Awareness Program',
                link: '/gallery/public-awareness-program'
            },
        ]
    },
    // {
    //     id: 88,
    //     title: 'Videos',
    //     link: '/videos',
    // },
    {
        id: 89,
        title: 'Join Us',
        link: '#',
        submenu: [
            {
                id: 51,
                title: 'Volunteer Opportunities',
                link: '/join-us/volunteer-opportunities'
            },
            {
                id: 52,
                title: 'Donate',
                link: '/join-us/donate'
            },
        ]
    },

    {
        id: 100,
        title: 'Our Bulletin',
        link: '#',
        submenu: [
            {
                id: 101,
                title: 'Blogs',
                link: '/our-bulletin/blogs'
            },
            {
                id: 102,
                title: 'Newsletters',
                link: '/our-bulletin/newsletters'
            },
        ]
    },
    // {
    //     id: 90,
    //     title: 'Contact Us',
    //     link: '/contact-us',
    // },


]

const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <ul className="main_menu_list clearfix">
            {menus.map((item, mn) => {
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'ti-minus' : 'ti-plus'}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="subMenu">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <ListItem key={i}>
                                                        <Link onClick={ClickHandler} className="active"
                                                            to={submenu.link}>{submenu.title}</Link>
                                                    </ListItem>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                </Collapse>
                            </Fragment>
                            : <Link className="active"
                                to={item.link}>{item.title}</Link>
                        }
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default MobileMenu;